module.exports = __webpack_public_path__ + "face-triggerArr.b9713c54.gif";